'use strict';

var CmdDevice = require('./util/CmdDevice');
var log = require('../../../log/Log').channel('EikiProjector400Series');

function EikiProjector400Series(ipAddress, username, password, onConnectStatus, onControlStatus, config) {
    this.busy = false;
    this.firmwareVersion = 'unknown';
    this.lampLife = 0;
    this.power = false;
    this.videoInput = null;
    this.displayBlank = false;
    this.pollCycle = 0;
    this.slowPollCycle = 0;

    CmdDevice.call(this, ipAddress, username, password, onConnectStatus,
        onControlStatus, config);
}

EikiProjector400Series.prototype = Object.create(CmdDevice.prototype);

EikiProjector400Series.prototype.constructor = EikiProjector400Series;

EikiProjector400Series.prototype.name = 'EikiProjector400Series';
EikiProjector400Series.prototype.key = '-LzCuBwYZFV_GU1VFsBU';
EikiProjector400Series.prototype.isAsync = false;
EikiProjector400Series.prototype.rejectAsync = false;
EikiProjector400Series.prototype.syncTimeoutMs = 2000;
EikiProjector400Series.prototype.pollIntervalMs = 2000;
EikiProjector400Series.prototype.sendTerminator = '\r';

EikiProjector400Series.prototype.pollParamsFast = [ '$getInput', '$getDisplayBlank' ];
EikiProjector400Series.prototype.pollParamsSlow = [ '$getLampHours' ];

EikiProjector400Series.prototype.ports = [{
    port: 23,
    verifySend: 'V99G0007',
    verifyConnection: /P\d+|F|OK|ERR/i,
    verifyTimeoutMs: 3000,
    loginSkip: null,
    loginVerifyTimeoutMs: 0,
    passwordPrompt: null,
    passwordPromptTimeoutMs: 0,
    passwordDefault: null,
    passwordSend: null,
    loginVerify: null,
    loginReject: null,
},{
    port: 4999,
    verifySend: 'V99G0007',
    verifyConnection: /P\d+|F|OK|ERR/i,
    verifyTimeoutMs: 3000,
    loginSkip: null,
    loginVerifyTimeoutMs: 0,
    passwordPrompt: null,
    passwordPromptTimeoutMs: 0,
    passwordDefault: null,
    passwordSend: null,
    loginVerify: null,
    loginReject: null,
}];

EikiProjector400Series.prototype.simulationParams = {
    caps: {
        hasPowerControl: true,
        hasVideoInputs: true,
        hasVideoSwitcher: true,
        hasDisplayBlank: true,
        hasFirmwareVersion: true,
    },
    firmwareVersion: '2.2',
};

EikiProjector400Series.prototype.commands = {};

EikiProjector400Series.prototype.commands.$getDisplayBlank = {};
EikiProjector400Series.prototype.commands.$getDisplayBlank.get = function() {
    if (!this.power) return;  // Only poll while device is powered on
    if (this.hasSync('$getDisplayBlank')) return;
    this.sendCommand('$getDisplayBlank', 'V99G0302');
};
EikiProjector400Series.prototype.commands.$getDisplayBlank.match = /P(\d+)|F|OK|ERR/i;
EikiProjector400Series.prototype.commands.$getDisplayBlank.process = function(match) {
    if (typeof match[1] !== 'undefined') {
        var newDisplayBlank = match[1] === '1' ? true : false;

        if (this.displayBlank !== newDisplayBlank) {
            this.displayBlank = newDisplayBlank;
            this.broadcastStatus('displayBlank', this.displayBlank);
        }
    }
};

EikiProjector400Series.prototype.commands.$getInput = {};
EikiProjector400Series.prototype.commands.$getInput.get = function() {
    if (!this.power) return;  // Only poll while device is powered on
    if (this.hasSync('$getInput')) return;
    if (!this.config.hasOwnProperty('videoInputs')) return;
    this.sendCommand('$getInput', 'V99G0220');
};
EikiProjector400Series.prototype.commands.$getInput.match = /P(\d+)|F|OK|ERR/i;
EikiProjector400Series.prototype.commands.$getInput.process = function(match) {
    if (typeof match[1] !== 'undefined') {
        this.updateVideoInput(match[1]);
    } else {
        log.debug(this + ': Did not match a video input');
    }
};

EikiProjector400Series.prototype.commands.$getLampHours = {};
EikiProjector400Series.prototype.commands.$getLampHours.get = function() {
    if (!this.power) return;  // Only poll while device is powered on
    if (this.hasSync('$getLampHours')) return;
    this.sendCommand('$getLampHours', 'V99G0004');
};
EikiProjector400Series.prototype.commands.$getLampHours.match = /P(\d+)|F|OK|ERR/i;
EikiProjector400Series.prototype.commands.$getLampHours.process = function(match) {
    this.lampLife = parseInt(match[1],10);
    this.broadcastStatus ('lampLife', this.lampLife);
};

EikiProjector400Series.prototype.commands.busy = {};
EikiProjector400Series.prototype.commands.busy.get = function() {
    this.broadcastStatus('busy', this.busy);
};

EikiProjector400Series.prototype.commands.displayBlank = {};
EikiProjector400Series.prototype.commands.displayBlank.get = function() {
    this.broadcastStatus('displayBlank', this.displayBlank);
};
EikiProjector400Series.prototype.commands.displayBlank.set = function(value) {
    this.cmdSocket.removeSync('displayBlank');
    this.sendCommand('displayBlank', 'PIMU   ' + (value === true ? '1' : '0'));
    this.displayBlank = value;
    this.broadcastStatus('displayBlank', this.displayBlank);
};
EikiProjector400Series.prototype.commands.displayBlank.match = /P|F|OK|ERR/i;

EikiProjector400Series.prototype.commands.firmwareVersion = {};
EikiProjector400Series.prototype.commands.firmwareVersion.get = function() {
    if (this.hasSync('firmwareVersion')) return;
    this.sendCommand('firmwareVersion', 'V99G0008');
};
EikiProjector400Series.prototype.commands.firmwareVersion.match = /(.+)|^F$|OK|ERR/i;
EikiProjector400Series.prototype.commands.firmwareVersion.process = function (match) {
    if (typeof match[1] !== 'undefined') {
        this.broadcastStatus('firmwareVersion', match[1]);
    }
};

EikiProjector400Series.prototype.commands.ping = {};
EikiProjector400Series.prototype.commands.ping.activeStates = [ 'controlling', 'controlFailed' ];
EikiProjector400Series.prototype.commands.ping.get = function() {
    this.sendCommand('ping', 'V99G0007');
};
EikiProjector400Series.prototype.commands.ping.match = /P(\d+)|F/i;
EikiProjector400Series.prototype.commands.ping.process = function(match) {
    if (typeof match[1] !== 'undefined') {
        var newPower = match[1] === '2' ? true : false;

        if (this.power !== newPower) {
            this.power = newPower;
            this.broadcastStatus('power', this.power);
        }
    }
};

EikiProjector400Series.prototype.commands.power = {};
EikiProjector400Series.prototype.commands.power.syncTimeoutMs = EikiProjector400Series.prototype.syncTimeoutMs;
EikiProjector400Series.prototype.commands.power.resumeDelayMs = 3000;
EikiProjector400Series.prototype.commands.power.get = function() {
    this.broadcastStatus('power', this.power);
};
EikiProjector400Series.prototype.commands.power.set = function(value) {
    this.power = value;
    this.broadcastStatus('power', this.power);
    this.removePollCommands();
    this.cmdSocket.removeSync('power');
    this.sendCommand('power', value === true ? 'V99S0001' : 'V99S0002');
    this.setBusy(true, 0);
    this.setBusy(false, 8000);
};
EikiProjector400Series.prototype.commands.power.match = /P|F/i;

EikiProjector400Series.prototype.commands.videoInput = {};
EikiProjector400Series.prototype.commands.videoInput.get = function() {
    if (!this.config.hasOwnProperty('videoInputs')) {
        log.error(this + ': videoInput: get: no videoInputs in config: ' +
            JSON.stringify(this.config, null, 4));
        return;
    }

    this.broadcastStatus('videoInput', this.videoInput);
};
EikiProjector400Series.prototype.commands.videoInput.set = function(srcId) {
    if (!this.config.hasOwnProperty('videoInputs')) {
        log.error(this + ': videoInput: set: no videoInputs in config: ' +
            JSON.stringify(this.config, null, 4));
        return;
    }

    if (!this.config.videoInputs.hasOwnProperty(srcId)) {
        log.error(this + ': videoInput: set: srcId = ' + srcId +
            ' not present in videoInputs for config = ' +
            JSON.stringify(this.config, null, 4));
    }

    this.removePollCommands();
    var code = this.config.videoInputs[srcId].code;
    this.cmdSocket.removeSync('videoInput');
    this.sendCommand('videoInput', 'V99S02' + this.zeroFill(code, 2));

    if (this.videoInput !== srcId) {
        this.videoInput = srcId;
        this.broadcastStatus('videoInput', this.videoInput);
    }
};
EikiProjector400Series.prototype.commands.videoInput.match = /P|F|OK|ERR/i;

EikiProjector400Series.prototype.getVideoInputFromCode = function(code) {
    for (var srcId in this.config.videoInputs) {
        if (!this.config.videoInputs.hasOwnProperty(srcId)) continue;

        if (code === this.config.videoInputs[srcId].code) {
            return srcId;
        }
    }

    log.warning(this + ': unmatched video input code: ' + code);

    return null;
};

EikiProjector400Series.prototype.onComputeCaps = function() {
    var caps = this.getCapsTemplate();
    caps.hasPowerControl = true;
    caps.hasVideoSwitcher = true;
    this.computeCapsFromConfig(caps);
    caps.hasDisplayBlank = true;
    caps.hasBusy = true;
    caps.hasFirmwareVersion = true;

    return caps;
};

EikiProjector400Series.prototype.onInitialize = function() {
    this.busy = false;
    // Poll all the parameters on the first poll cycle.

    this.pollParams = this.pollParamsFast.concat(this.pollParamsSlow);
    this.finishInitialization();
};

EikiProjector400Series.prototype.onPoll = function() {
    if (this.pollCycle < 0 || this.pollCycle >= this.pollParams.length) {
        this.pollCycle = 0;
    }

    this.query(this.pollParams[this.pollCycle]);
    this.pollCycle++;

    if (this.pollCycle >= this.pollParams.length) {
        this.pollCycle = 0;

        this.slowPollCycle++;

        if (this.slowPollCycle >= 100) {
            this.pollParams = this.pollParamsFast.concat(this.pollParamsSlow);
            this.slowPollCycle = 0;
        } else {
            this.pollParams = this.pollParamsFast;
        }
    }
};

EikiProjector400Series.prototype.removePollCommands = function() {
    for (var i = 0; i < this.pollParams.length; i++) {
        this.cmdSocket.removeSync(this.pollParams[i]);
    }
};

EikiProjector400Series.prototype.updateVideoInput = function(code) {
    var foundId = this.getVideoInputFromCode(code);

    if (this.videoInput !== foundId) {
        this.videoInput = foundId;
        this.broadcastStatus('videoInput', this.videoInput);
    }
};

EikiProjector400Series.prototype.zeroFill = function (value, numDigits) {
    var newValue = value.toString(10);
    var len = newValue.length;
    for (var i = len; i < numDigits; i++) {
        newValue = '0' + newValue;
    }

    return newValue;
};

module.exports = EikiProjector400Series;
